import styled from "styled-components";

const CardList = styled.ul`
  li b {
    font-weight: 600;
  }
`;

export default CardList;
